export default function getIntlKeyMessages(originalMessages: Record<string, string>) {
  return Object.keys(originalMessages).reduce((acc, cur) => {
    acc[cur] = cur;
    return acc;
  }, {});
}
